import React, { useEffect, useState } from "react";
import { fetchSiteTypes, createSiteType, deleteSiteType as deleteSiteTypeApi } from "./services/api";
import { PMSiteType } from "./types";
import { Button, Col, Form, Row } from "react-bootstrap";

const SiteTypePage: React.FC = () => {
    const [siteTypes, setSiteTypes] = useState<PMSiteType[]>([]);
    const [newType, setNewType] = useState<string>("");

    useEffect(() => {
        getSiteTypes();
    }, []);

    const getSiteTypes = async () => {
        const res = await fetchSiteTypes();
        setSiteTypes(res);
    };

    const addSiteType = async () => {
        if (!newType) return;
        await createSiteType(newType);
        setNewType("");
        fetchSiteTypes();
    };

    const deleteSiteType = async (id?: number) => {
        await deleteSiteTypeApi(id);
        fetchSiteTypes();
    };

    return (
        <div className="p-4 p-md-5">
            <h2 className="mb-4">Site Types</h2>
            <Form className="mb-3">
                <Row className="g-2 align-items-center">
                    <Col md={6}>
                        <Form.Group className="mb-4">
                            <Form.Label>Type Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter type name"
                                value={newType}
                                onChange={e => setNewType(e.target.value)}
                            /></Form.Group>
                    </Col>
                    <Col md={3}>
                        <Button className="btn btn-primary" onClick={addSiteType}>
                            Add
                        </Button>
                    </Col>
                </Row>
            </Form>

            {/* Table */}
            <div className="row">
                <div className="col-md-8">
                    <table className="table table-bordered align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: "10%" }}>ID</th>
                                <th>Type Name</th>
                                <th style={{ width: "15%" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {siteTypes.length > 0 ? (
                                siteTypes.map((st) => (
                                    <tr key={st.id}>
                                        <td>{st.id}</td>
                                        <td>{st.type_name}</td>
                                        <td>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => deleteSiteType(st.id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        No site types found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SiteTypePage;
